/**
 * TagDetailPresenter
 * --
 */
import { useState, useMemo } from 'react';
import { Content, Title, Row, Col } from 'components';
import { styles } from './styles';
import {
  SearchTag,
  ProductSummary,
  SearchedTagList,
  SelectedTagList,
  ProductList,
} from './components';
import moment from 'moment';
import MenuManagementContainer from 'routes/store.routes/store.store/MenuManagement';

const TagDetailPresenter = ({ tagList }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedTag, setSelectedTag] = useState([]);
  const [search, setSearch] = useState(null);
  // console.log('tagList====>', tagList);
  /* ===== VARIABLE ===== */
  const products = useMemo(() => {
    const map = {};
    return selectedTag.reduce((acc, cur) => {
      const { products } = cur;
      if (Array.isArray(products) && products.length > 0) {
        products.forEach((product) => {
          if (!map[product.product_id]) {
            acc.push(product);
            map[product.product_id] = true;
          }
        });
      }
      return acc;
    }, []);
  }, [selectedTag]);

  /* ===== FUNCTION ===== */
  const handleChangeSelectedTagList = (newSelectedTag) => {
    setSelectedTag(newSelectedTag);
  };

  const filteredTagList = () => {
    let tags = tagList;
    if (!search) {
      return tags;
    }

    if (search.is_visible) {
      tags = tags.filter((tag) => {
        if (search.is_visible === 'visible') {
          if (tag.is_show === 'Y') {
            return true;
          }

          return false;
        } else if (search.is_visible === 'in_visible') {
          if (tag.is_show === 'N') {
            return true;
          }

          return false;
        }

        return true;
      });
    }

    if (search.tag_name) {
      tags = tags.filter((tag) => {
        if (tag.tag_name.includes(search.tag_name)) {
          return true;
        }

        return false;
      });
    }

    if (search.dates) {
      const [from, to] = search.dates;
      if (!from && !to) return tags;

      const mFrom = moment(from, 'YYYY-MM-DD');
      const mTo = moment(to, 'YYYY-MM-DD');

      tags = tags.filter((tag) => {
        const date = moment.unix(tag.created_at);

        if (!from) {
          return date.isSameOrBefore(mTo);
        } else if (date.isBetween(mFrom, mTo, 'day', [])) {
          return true;
        }

        return false;
      });
    }

    return tags;
  };
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>태그 상세정보</Title>

          {/* 검색필터 */}
          <SearchTag onChange={setSearch} />
          {/* 검색필터 끝 */}

          {/* 검색된 태그 */}
          <SearchedTagList
            tagList={filteredTagList()}
            selectedTagList={selectedTag}
            onChangeSelectedTagList={handleChangeSelectedTagList}
          />
          {/* 검색된 태그 끝 */}

          {/* 선택된 태그 */}
          <SelectedTagList selectedTagList={selectedTag} />
          {/* 선택된 태그 끝 */}

          {/* 검색결과 */}
          <ProductList productList={products} />
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default TagDetailPresenter;
